module.exports = __webpack_public_path__ + "static/media/AWS_APN_PartnerNetwork_ImmersionDay_Dark.a72e470e.png";